var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletHeaderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14619_6463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 21.8333C19.8555 21.8333 17.5 19.4778 17.5 16.5833C17.5 13.6888 19.8555 11.3333 22.75 11.3333H25.6667V9C25.6667 7.71317 24.6202 6.66667 23.3333 6.66667H22.1667V4.33333C22.1667 3.0465 21.1202 2 19.8333 2H3.5C1.76983 2 0.3395 3.26467 0.0595 4.9155C0.0338333 5.01117 0 5.1045 0 5.20833V23C0 24.9297 1.57033 26.5 3.5 26.5H23.3333C24.6202 26.5 25.6667 25.4535 25.6667 24.1667V21.8333H22.75ZM2.33333 5.5C2.33333 4.85717 2.856 4.33333 3.5 4.33333H19.8333V6.66667H3.5C2.856 6.66667 2.33333 6.14283 2.33333 5.5Z",
    fill: "url(#paint0_linear_14619_6463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.125 13.083H22.75C20.8203 13.083 19.25 14.6533 19.25 16.583C19.25 18.5127 20.8203 20.083 22.75 20.083H27.125C27.608 20.083 28 19.691 28 19.208V13.958C28 13.475 27.608 13.083 27.125 13.083ZM22.75 17.7497C22.106 17.7497 21.5833 17.227 21.5833 16.583C21.5833 15.939 22.106 15.4163 22.75 15.4163C23.394 15.4163 23.9167 15.939 23.9167 16.583C23.9167 17.227 23.394 17.7497 22.75 17.7497Z",
    fill: "url(#paint1_linear_14619_6463)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14619_6463",
    x1: 0.313009,
    y1: 2.98,
    x2: 26.0937,
    y2: 7.01713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915334,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14619_6463",
    x1: 19.3567,
    y1: 13.363,
    x2: 28.0574,
    y2: 14.9887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915334,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14619_6463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletHeaderIcon);
export default __webpack_public_path__ + "static/media/WalletHeaderIcon.6b12acf5.svg";
export { ForwardRef as ReactComponent };